window.BraSizeQuiz = {
  data: {
    unit: 'in', // 'in' or 'cm'
    bandSize: null,
    cupSize: null,
    directResult: null,
    scores: { band: {}, cup: {} },

    // Inches
    bandSizes: [28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52],

    // Cup progression (no "I")
    cupSizes: ['AA','A','B','C','D','DD','E','F','FF','G','GG','H','HH','J','JJ','K','KK','L','M'],

    // CM arrays (per spec)
    cmBandSizes: [71.12, 76.2, 81.28, 86.36, 91.44, 96.52, 101.6, 106.68, 111.76, 116.84, 121.92, 127.0, 132.08],
    cmOverbust:  [71.12, 73.66, 76.2, 78.74, 81.28, 83.82, 86.36, 88.9, 91.44, 93.98, 96.52, 99.06, 101.6, 104.14, 106.68, 109.22, 111.76, 114.3, 116.84, 119.38, 121.92, 124.46, 127.0, 129.54, 132.08, 134.62, 137.16, 139.7, 142.24, 144.78, 147.32, 149.86]
  },

  /* ===== Utilities ===== */
  toInches(cm) { return cm / 2.54; },
  toCM(inches) { return inches * 2.54; },
  round2(n) { return Math.round(n * 100) / 100; },

  canonicalCup(cup) {
    const up = String(cup || '').toUpperCase().trim();
    return up === 'I' ? 'HH' : up;
  },

  getActiveUnderOptions() {
    return this.data.unit === 'in' ? this.data.bandSizes : this.data.cmBandSizes;
  },
  getActiveOverOptions() {
    return this.data.unit === 'in'
      ? Array.from({ length: 59 - 28 + 1 }, (_, i) => 28 + i)
      : this.data.cmOverbust;
  },

  labelWithUnit(value) {
    return this.data.unit === 'in' ? `${value} in` : `${this.round2(value)} cm`;
  },

  /* Populate the calculator selects based on unit */
  renderMeasurementOptions(preserveSelection = true) {
    const underSelect = document.getElementById('calcUnderbust');
    const overSelect  = document.getElementById('calcOverbust');
    if (!underSelect || !overSelect) return;

    document.documentElement.setAttribute('data-quiz-unit', this.data.unit);

    const prevUnder = underSelect.value ? Number(underSelect.value) : '';
    const prevOver  = overSelect.value ? Number(overSelect.value) : '';

    const resetSelect = (sel, placeholder) => {
      sel.innerHTML = '';
      const opt = document.createElement('option');
      opt.value = '';
      opt.selected = true;
      opt.disabled = true;
      opt.textContent = placeholder;
      sel.appendChild(opt);
    };

    resetSelect(underSelect, 'Select Underbust');
    resetSelect(overSelect,  'Select Overbust');

    const underOptions = this.getActiveUnderOptions();
    const overOptions  = this.getActiveOverOptions();

    underOptions.forEach((v) => {
      const o = document.createElement('option');
      o.value = String(v);
      o.textContent = this.labelWithUnit(v);
      underSelect.appendChild(o);
    });
    overOptions.forEach((v) => {
      const o = document.createElement('option');
      o.value = String(v);
      o.textContent = this.labelWithUnit(v);
      overSelect.appendChild(o);
    });

    const underBadge = document.getElementById('underUnitLabel');
    const overBadge  = document.getElementById('overUnitLabel');
    const unitText = this.data.unit === 'in' ? 'in' : 'cm';
    if (underBadge) underBadge.textContent = `(${unitText})`;
    if (overBadge)  overBadge.textContent  = `(${unitText})`;

    if (!preserveSelection) return;

    if (prevUnder !== '') {
      let targetUnder = '';
      if (this.data.unit === 'cm') {
        const idx = this.data.bandSizes.indexOf(prevUnder);
        if (idx >= 0) targetUnder = this.data.cmBandSizes[idx];
      } else {
        const idx = this.data.cmBandSizes.indexOf(prevUnder);
        if (idx >= 0) targetUnder = this.data.bandSizes[idx];
      }
      if (targetUnder !== '') underSelect.value = String(targetUnder);
    }

    if (prevOver !== '') {
      let targetOver = '';
      if (this.data.unit === 'cm') {
        const cmVal = Math.ceil(this.toCM(prevOver) * 100) / 100;
        targetOver = this.data.cmOverbust.find(v => v >= cmVal);
      } else {
        const inch = Math.round(this.toInches(prevOver));
        targetOver = String(inch);
      }
      if (targetOver !== '' && overOptions.map(Number).includes(Number(targetOver))) {
        overSelect.value = String(targetOver);
      }
    }
  },

  /* ===== Navigation helpers ===== */
  goToQuestion(q) {
    document.querySelectorAll('.quiz-question').forEach(el => el.classList.remove('active'));
    const target = document.querySelector('.quiz-question[data-question="' + q + '"]');
    if (target) target.classList.add('active');
    const container = document.querySelector('.quiz-container');
    if (container) container.scrollIntoView({ behavior: 'smooth', block: 'start' });
  },
  goToStart() {
    this.goToQuestion('start');
    document.querySelectorAll('.quiz-button.selected, .selected')
      .forEach(el => el.classList.remove('selected'));
  },

  /* ===== Calculator ===== */
  setDirectResult(band, cup) {
    this.data.directResult = { band: parseInt(band, 10), cup: this.canonicalCup(cup) };
  },

  calculateSize() {
    const underEl = document.getElementById('calcUnderbust');
    const overEl  = document.getElementById('calcOverbust');
    let under = underEl && underEl.value ? Number(underEl.value) : NaN;
    let over  = overEl && overEl.value ? Number(overEl.value) : NaN;

    if (!under || !over) { alert('Please choose both measurements.'); return; }

    if (this.data.unit === 'cm') {
      const idx = this.data.cmBandSizes.indexOf(under);
      const bandInches = (idx >= 0) ? this.data.bandSizes[idx] : Math.round(this.toInches(under));
      under = bandInches;
      over = Math.round(this.toInches(over));
    }

    if (under > over) {
      alert("We’re unable to calculate your size because your underbust measurement is larger than your overbust—please double-check and re-enter.");
      return;
    }

    const diff = Math.max(0, over - under);
    const map  = ['AA','A','B','C','D','DD','E','F','FF','G','GG','H','HH','J','JJ','K','KK','L','M','M'];
    const cup  = map[Math.min(diff, map.length - 1)];
    this.setDirectResult(under, cup);

    this.goToQuestion('email');
  },

  /* ===== Result calculation ===== */
  computeResult() {
    if (this.data.directResult) {
      return {
        newBandSize: this.data.directResult.band,
        newCupSize: this.data.directResult.cup,
        bandStep: 0,
        cupAdjustment: 0
      };
    }

    let bandAdjustment = 0, cupAdjustment = 0;
    Object.values(this.data.scores.band).forEach(s => bandAdjustment += s);
    Object.values(this.data.scores.cup).forEach(s => cupAdjustment += s);

    const currentBand = parseInt(this.data.bandSize, 10);
    let bandIndex = this.data.bandSizes.indexOf(currentBand);
    if (bandIndex < 0) {
      bandIndex = Math.max(0, this.data.bandSizes.findIndex(b => b >= currentBand));
      if (bandIndex < 0) bandIndex = 0;
    }

    const bandStep = Math.max(-2, Math.min(2, bandAdjustment));
    const newBandIndex = Math.max(0, Math.min(bandIndex + bandStep, this.data.bandSizes.length - 1));
    const newBandSize = this.data.bandSizes[newBandIndex];

    let startCup = this.canonicalCup(this.data.cupSize);
    let cupIndex = this.data.cupSizes.indexOf(startCup);
    if (cupIndex < 0) cupIndex = 0;

    cupIndex = Math.max(0, Math.min(cupIndex + cupAdjustment, this.data.cupSizes.length - 1));
    const newCupSize = this.data.cupSizes[cupIndex];

    return { newBandSize, newCupSize, bandStep, cupAdjustment };
  },

  /* ===== Results display ===== */
  showResults() {
    const { newBandSize, newCupSize, bandStep, cupAdjustment } = this.computeResult();

    let displaySize = String(newBandSize) + newCupSize;
    let hhMessage = '';

    if (newCupSize === 'HH') {
      displaySize = `${newBandSize}HH / ${newBandSize} I`;
      hhMessage = `Your size is ${newBandSize}HH, but some brands may not sell double cup sizes. In that case we recommend a ${newBandSize} I.`;
    }

    const finalSize = document.getElementById('finalSize');
    if (finalSize) finalSize.textContent = displaySize;

    const headingEl = document.getElementById('resultsHeading');
    const noteEl = document.getElementById('resultNote');
    const signed = (n) => (n > 0 ? `+${n}` : `${n}`);

    if (headingEl) {
      if (this.data.directResult) {
        headingEl.textContent = 'Your measurements show your recommended size is…';
      } else {
        headingEl.textContent = `Based on your answers, we adjusted your size by ${signed(bandStep)} in the band and ${signed(cupAdjustment)} in the cup. Your recommended size is…`;
      }
    }

    if (noteEl) {
      noteEl.innerHTML = hhMessage ? `<p>${hhMessage}</p>` : '';
    }

    const collectionLink = document.getElementById('collectionLink');
    if (collectionLink) {
      const sizeHandle = (String(newBandSize) + newCupSize).toLowerCase() + '-bra';
      collectionLink.href = '/collections/' + sizeHandle;
    }
  },

  /* ===== Persist + retrieve result across reloads ===== */
  getResultString() {
    if (this.data.directResult) {
      return `${this.data.directResult.band}${this.data.directResult.cup}`;
    }
    const { newBandSize, newCupSize } = this.computeResult();
    return `${newBandSize}${newCupSize}`;
  },

  saveSizeToStorage() {
    try { localStorage.setItem('bfm_quiz_size', this.getResultString()); } catch (e) {}
  },

  loadSizeFromStorage() {
    try { return localStorage.getItem('bfm_quiz_size') || ''; } catch (e) { return ''; }
  },

  clearSizeFromStorage() {
    try { localStorage.removeItem('bfm_quiz_size'); } catch (e) {}
  },

  /* ===== Email submit: native POST with explicit return_to ===== */
  bindEmailSubmit() {
    const form    = document.getElementById('quizEmailForm');
    const tagsInp = document.getElementById('quiz_contact_tags');
    const email   = document.getElementById('customerEmail');
    const btn     = document.getElementById('quizSubmitBtn');

    if (!form || !tagsInp || !email) return;

    // mark form to avoid theme AJAX hijack
    form.setAttribute('data-bfm-quiz-form', 'true');

    // ensure return_to exists and points back to this quiz page's results anchor
    let returnInput = form.querySelector('input[name="return_to"]');
    if (!returnInput) {
      returnInput = document.createElement('input');
      returnInput.type = 'hidden';
      returnInput.name = 'return_to';
      form.appendChild(returnInput);
    }

    form.addEventListener('submit', (e) => {
      if (!email.value) {
        e.preventDefault();
        email.focus();
        return;
      }

      // Build return_to = current path + ?quiz_subscribed=1#quiz-results
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('quiz_subscribed', '1');
        url.hash = 'quiz-results';
        returnInput.value = url.pathname + url.search + url.hash; // relative path preferred
      } catch (_) {
        // fallback
        returnInput.value = window.location.pathname + '?quiz_subscribed=1#quiz-results';
      }

      const size = this.getResultString().replace(/,/g, ' ').trim(); // e.g. "34D"
      tagsInp.value = `newsletter, quiz customer, ${size}`;

      // Persist size through the post/redirect
      this.saveSizeToStorage();

      // Let Shopify handle the POST natively (no preventDefault!)
      btn?.setAttribute('disabled', 'disabled');
      btn?.classList.add('is-loading');
    });
  },

  /* ===== Bindings ===== */
  bindUnitToggle() {
    const unitIn = document.getElementById('unitInches');
    const unitCm = document.getElementById('unitCM');
    if (!unitIn || !unitCm) return;

    const setAria = () => {
      unitIn.setAttribute('aria-checked', unitIn.checked ? 'true' : 'false');
      unitCm.setAttribute('aria-checked', unitCm.checked ? 'true' : 'false');
    };

    setAria();

    unitIn.addEventListener('change', () => {
      if (unitIn.checked) {
        this.data.unit = 'in';
        setAria();
        this.renderMeasurementOptions(true);
      }
    });

    unitCm.addEventListener('change', () => {
      if (unitCm.checked) {
        this.data.unit = 'cm';
        setAria();
        this.renderMeasurementOptions(true);
      }
    });
  },

  bindGlobalKeys() {
    document.addEventListener('keydown', (e) => {
      const tag = (document.activeElement && document.activeElement.tagName) || '';
      if (e.key === 'Enter' && !/INPUT|TEXTAREA|SELECT/.test(tag)) {
        const active = document.querySelector('.quiz-question.active');
        if (!active) return;
        const nextBtn = active.querySelector('.quiz-button[onclick*="nextQuestion"]');
        if (nextBtn && !nextBtn.disabled) nextBtn.click();
      }
    });
  },

  bindStartButtons() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.start-button');
      if (!btn) return;
      this.goToStart();
    });
  },

  bindTipToggles() {
    document.querySelectorAll('.tip-toggle').forEach((btn) => {
      const content = btn.nextElementSibling;
      if (!content) return;
      if (!btn.hasAttribute('aria-expanded')) btn.setAttribute('aria-expanded', 'false');
      if (!content.hasAttribute('id')) content.id = 'tip-' + Math.random().toString(36).slice(2, 9);
      btn.setAttribute('aria-controls', content.id);
      content.hidden = true;

      btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        content.hidden = expanded;
      });

      content.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        content.hidden = !expanded ? true : false;
      });
    });
  },

  bindInfoIcons() {
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a.info-icon');
      if (!a) return;
      const targetId = (a.getAttribute('href') || '').replace('#','');
      const tipEl = targetId ? document.getElementById(targetId) : null;
      if (!tipEl) return;
      const toggleBtn = tipEl.previousElementSibling;

      e.preventDefault();
      if (toggleBtn && toggleBtn.classList.contains('tip-toggle') && toggleBtn.getAttribute('aria-expanded') !== 'true') {
        toggleBtn.click();
      }
      if (window.matchMedia('(max-width: 767px)').matches) {
        setTimeout(() => tipEl.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
      }
    });
  },

  imageFallbacks() {
    const images = document.querySelectorAll('.question-image img');
    images.forEach((img) => {
      img.addEventListener('error', () => {
        const tried = img.getAttribute('data-tried') || '';
        const base = img.getAttribute('data-base');
        if (base) {
          if (tried !== 'jpg') {
            img.src = base + '.png';
            img.setAttribute('data-tried', 'jpg');
            return;
          } else if (tried !== 'png-tried') {
            img.src = base + '.jpg';
            img.setAttribute('data-tried', 'png-tried');
            return;
          }
        }
        img.style.display = 'none';
        if (img.parentElement && !img.parentElement.querySelector('.image-fallback-text')) {
          const p = document.createElement('p');
          p.className = 'image-fallback-text';
          p.textContent = 'Image not available';
          img.parentElement.appendChild(p);
        }
      });
    });
  },

  /* ===== Quiz flow ===== */
  selectAnswer(element, score, type) {
    const container = element.closest('.question-content');
    const buttons = container.querySelectorAll('.quiz-button:not([onclick*="nextQuestion"]), .answer-dropdown-menu .quiz-button');
    buttons.forEach((btn) => btn.classList.remove('selected'));
    element.classList.add('selected');

    const qNumber = element.closest('.quiz-question').getAttribute('data-question');
    this.data.scores[type][qNumber] = score;

    const nextButton = container.querySelector('.quiz-button[onclick*="nextQuestion"]');
    if (nextButton) nextButton.removeAttribute('disabled');
  },

  validateAnswer(questionNumber) {
    if (questionNumber === 1) {
      const band = document.getElementById('bandSize').value;
      let cup = document.getElementById('cupSize').value;
      cup = this.canonicalCup(cup);
      this._pendingCanonicalCup = cup;
      return band && cup;
    }
    const question = document.querySelector('.quiz-question[data-question="' + questionNumber + '"]');
    return question && question.querySelector('.quiz-button.selected') !== null;
  },

  nextQuestion(num) {
    if (num === 1) {
      const band = document.getElementById('bandSize').value;
      const rawCup = document.getElementById('cupSize').value;
      if (!band || !rawCup) { alert('Please select both band and cup size'); return; }
      this.data.bandSize = band;
      this.data.cupSize = this.canonicalCup(this._pendingCanonicalCup || rawCup);
      this.data.directResult = null;
    } else if (!this.validateAnswer(num)) {
      alert('Please select an answer before continuing');
      return;
    }

    const current = document.querySelector('.quiz-question[data-question="' + num + '"]');
    if (current) current.classList.remove('active');

    if (num === 9) {
      const emailQ = document.querySelector('.quiz-question[data-question="email"]');
      if (emailQ) emailQ.classList.add('active');
    } else {
      const next = document.querySelector('.quiz-question[data-question="' + (num + 1) + '"]');
      if (next) next.classList.add('active');
    }
  },

  prevQuestion(num) {
    const current = document.querySelector('.quiz-question[data-question="' + num + '"]');
    const prev = document.querySelector('.quiz-question[data-question="' + (num - 1) + '"]');
    if (current) current.classList.remove('active');
    if (prev) prev.classList.add('active'); // fixed bug (was: add(active))
  },

  skipEmailSignup() {
    const emailQ = document.querySelector('.quiz-question[data-question="email"]');
    const resultsQ = document.querySelector('.quiz-question[data-question="10"]');
    if (emailQ) emailQ.classList.remove('active');
    if (resultsQ) resultsQ.classList.add('active');
    this.showResults();
    // update hash for consistency
    try {
      const u = new URL(window.location.href);
      u.hash = 'quiz-results';
      history.replaceState(null, '', u.pathname + u.search + u.hash);
    } catch(_) {}
  },

  /* ===== Start-page button alignment ===== */
  alignStartButtons() {
    const cards = document.querySelectorAll('.start-card');
    if (cards.length !== 2) return;

    cards.forEach(c => {
      const intro = c.querySelector('.start-intro');
      if (intro) intro.style.minHeight = '';
    });

    const heights = Array.from(cards).map(c => {
      const intro = c.querySelector('.start-intro');
      return intro ? intro.getBoundingClientRect().height : 0;
    });
    const max = Math.max.apply(null, heights);
    cards.forEach(c => {
      const intro = c.querySelector('.start-intro');
      if (intro) intro.style.minHeight = max + 'px';
    });
  },

  /* ===== Start mode (mobile start-page toggle) ===== */
  bindStartModeToggle() {
    const root = document.documentElement;
    const current = root.getAttribute('data-start-mode');
    if (!current) root.setAttribute('data-start-mode', 'scratch');

    const scratch = document.getElementById('startModeScratch');
    const havebra = document.getElementById('startModeHavebra');
    if (!scratch || !havebra) return;

    const setAria = () => {
      scratch.setAttribute('aria-checked', scratch.checked ? 'true' : 'false');
      havebra.setAttribute('aria-checked', havebra.checked ? 'true' : 'false');
    };

    const mode = root.getAttribute('data-start-mode');
    if (mode === 'havebra') {
      havebra.checked = true;
      scratch.checked = false;
    } else {
      scratch.checked = true;
      havebra.checked = false;
    }
    setAria();

    scratch.addEventListener('change', () => {
      if (scratch.checked) {
        root.setAttribute('data-start-mode', 'scratch');
        setAria();
      }
    });
    havebra.addEventListener('change', () => {
      if (havebra.checked) {
        root.setAttribute('data-start-mode', 'havebra');
        setAria();
      }
    });
  },

  /* ===== Init ===== */
  init() {
    const firstNextButton = document.getElementById('firstQuestionNext');
    if (firstNextButton) firstNextButton.addEventListener('click', () => this.nextQuestion(1));

    this.bindUnitToggle();
    this.bindGlobalKeys();
    this.bindStartButtons();
    this.bindTipToggles();
    this.bindInfoIcons();
    this.imageFallbacks();

    this.renderMeasurementOptions(false);

    this.alignStartButtons();
    window.addEventListener('resize', () => this.alignStartButtons());

    const noToggle = document.getElementById('q6NoToggle');
    const noMenu = document.getElementById('q6NoMenu');
    if (noToggle && noMenu) {
      noToggle.addEventListener('click', () => {
        const expanded = noToggle.getAttribute('aria-expanded') === 'true';
        noToggle.setAttribute('aria-expanded', String(!expanded));
        noMenu.hidden = expanded;
      });
    }

    /* start-page mobile toggle */
    this.bindStartModeToggle();

    /* email submit handler (native POST + return_to) */
    this.bindEmailSubmit();

    /* Post-success detection:
       - data-bfm-quiz-posted (server-side flag)
       - or ?quiz_subscribed=1 in URL (client-side)
    */
    const hasServerFlag = document.documentElement.hasAttribute('data-bfm-quiz-posted');
    const url = new URL(window.location.href);
    const hasQueryFlag = url.searchParams.get('quiz_subscribed') === '1';

    if (hasServerFlag || hasQueryFlag) {
      const stored = this.loadSizeFromStorage();
      if (stored) {
        this.data.directResult = {
          band: parseInt(stored, 10),
          cup: stored.replace(String(parseInt(stored, 10)), '')
        };
        this.goToQuestion('10');
        this.showResults();
        this.clearSizeFromStorage();

        // Clean up URL params but keep #quiz-results
        try {
          url.searchParams.delete('quiz_subscribed');
          url.hash = 'quiz-results';
          history.replaceState(null, '', url.pathname + (url.search ? '?' + url.searchParams.toString() : '') + (url.hash ? '#' + url.hash : ''));
        } catch(_) {}
      }
    }
  }
};

document.addEventListener('DOMContentLoaded', function () {
  BraSizeQuiz.init();
});
